module.exports = __webpack_public_path__ + "static/img/eye.e4fe315c.svg";